module.exports = __webpack_public_path__ + "static/lead-bg-eabb2768a592b00352fa07cde6cc40eb.jpg";